import { api } from './api'

const creditApi = {
  /**
   * Get current credit balance
   * @returns {Promise<object>} Balance response
   */
  async getBalance() {
    return api.get('/credits/balance');
  },

  /**
   * Get transaction history
   * @param {object} filters - Filter options
   * @param {string} filters.type - Transaction type filter
   * @param {string} filters.service - Service filter
   * @param {number} filters.limit - Limit results
   * @param {number} filters.offset - Offset for pagination
   * @param {string} filters.sortBy - Sort field
   * @param {string} filters.order - Sort order (asc/desc)
   * @returns {Promise<object>} Transaction history with pagination
   */
  async getHistory(filters = {}) {
    return api.get('/credits/history', {
      params: filters
    });
  }
};

export default creditApi;
